import {
  TMinCartLimit,
  TMinCartLimitListPayload,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const minCartLimitService = emptySplitApi
  .enhanceEndpoints({ addTagTypes: ['list'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllStatesMinCartLimitList: builder.query<
        { data: TMinCartLimit[]; totalCount: number },
        TMinCartLimitListPayload
      >({
        query: (params) => ({
          url: 'states-afs',
          method: 'GET',
          params: {
            page: params.pageNo,
            size: params.pageSize,
          },
        }),
        transformResponse: (
          data: TMinCartLimit[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['list'],
      }),
      getMinCartLimitDetails: builder.query<
        TMinCartLimit,
        string
      >({
        query: (id) => ({
          method: 'GET',
          url: `states/${id}`,
        }),
      }),
      updateMinimumCartValue: builder.mutation<
        TMinCartLimit,
        TMinCartLimit
      >({
        query: (data) => {
          return {
            url: 'states',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['list'],
      }),
    }),
  });

export const {
  useGetAllStatesMinCartLimitListQuery,
  useGetMinCartLimitDetailsQuery,
  useUpdateMinimumCartValueMutation,
} = minCartLimitService;
